import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const statistiquesEducationData = [
    {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'RAPPORT DES DONNEES SUR LES GROSSESSES CHEZ LES ELEVES, EDITION 2024-2025',
    description: 'Ce rapport présente une analyse approfondie des données sur les grossesses chez les élèves du système éducatif burundais pour l’année scolaire 2024-2025. ',
    date: "2026-03-03",
    link: "/documents/Sectorials/Rapports_sur_grossesses_2024_2025.pdf"
  },
   {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'RAPPORT D’ANALYSE DES DONNEES DES ELEVES A BESOINS SPECIFIQUES DU SYSTEME EDUCATIF DU BURUNDI',
    description: 'Ce rapport offre une analyse détaillée des données concernant les élèves à besoins spécifiques dans le système éducatif burundais pour l’année scolaire 2024-2025. ',
    date: "2026-03-03",
    link: "/documents/Sectorials/Rapport_des_eleves _besoins_specifiques_2024-2025.pdf"
  },
   {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2024 - 2025 TOME 3',
    description: 'Ce volume présente des données statistiques détaillées sur l’enseignement supérieur, notamment concernant l’accès à l’éducation, les taux d’inscription, et l’évaluation des performances académiques pour l’année académique 2024-2025.',
   date: "2026-03-03",
    link: "/documents/Sectorials/Tome_3_Annuaire_2024_2025.pdf"
  },
    {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2024 - 2025 TOME 2',
    description: 'Ce volume présente une analyse approfondie des statistiques des écoles du post-fondamental général, pédagogique, technique, et des centres d’enseignement des métiers ou de formation professionnelle pour l’année scolaire 2024-2025.',
   date: "2026-03-03",
    link: "/documents/Sectorials/Tome_2_Annuaire__2024_2025.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2024 - 2025 TOME 1',
    description: 'Ce volume compile des données statistiques sur l’enseignement préscolaire et fondamental pour l’année scolaire 2024-2025, mettant en lumière les taux d’inscription, les taux d’abandon, et les initiatives pédagogiques mises en place pour améliorer les résultats scolaires et l’expérience d’apprentissage des élèves.',
   date: "2026-03-03",
    link: "/documents/Sectorials/Tome_1_Annuaire__2024_2025.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2023 TOME 3',
    description: 'Ce volume fournit des données statistiques détaillées sur l’enseignement supérieur, notamment concernant l’accès à l’éducation, les taux d’inscription, et l’évaluation des performances académiques pour l’année académique 2022-2023. Une ressource essentielle pour comprendre les dynamiques actuelles dans le secteur de l’enseignement supérieur.',
    date: "2023-12-31",
    link: "/documents/Sectorials/T3_AnnuStat-Sup2022_2023_final.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'Annuaire statistique 2022-2023 TOME 2',
    description: 'Ce rapport présente une vue d’ensemble des statistiques des écoles, englobant les établissements post-fondamentaux et de formation professionnelle. Il met également en lumière les évolutions observées durant l’année académique, fournissant une analyse précieuse pour les éducateurs et les décideurs.',
    date: "2023-12-31",
    link: "/documents/Sectorials/T2-ANNUAIRE-2022-2023_VF_final.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2023 TOME 1',
    description: 'Ce volume offre des données clés sur l’enseignement préscolaire et fondamental pour l’année scolaire 2022-2023, notamment les taux d’inscription et d’abandon. Il révèle également les initiatives pédagogiques mises en place pour améliorer les résultats scolaires et l’expérience d’apprentissage des élèves.',
    date: "2023-12-31",
    link: "/documents/Sectorials/T1_Annuaire_2022_2023_VF_corrige_13_03_2024.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2022 TOME 2',
    description: 'Ce rapport présente des données importantes concernant l’enseignement supérieur, illustrant les systèmes éducatifs à travers divers indicateurs de performance. C’est une ressource indispensable pour les chercheurs et les décideurs souhaitant évaluer la situation éducative actuelle.',
    date: "2022-12-31",
    link: "/documents/Sectorials/T3_Annuaire_Sup_2021-2022_VF.pdf"
  },
  {
    ministere: 'Ministère de l’Éducation Nationale et de la Recherche Scientifique',
    annuaires: 'ANNUAIRE STATISTIQUE ÉDITION 2022 TOME 1',
    description: 'Ce volume compile des données statistiques sur l’enseignement préscolaire et fondamental, détaillant les tendances d’inscription et les enjeux pédagogiques rencontrés. Une lecture essentielle pour les acteurs du secteur éducatif et les responsables politiques.',
    date: "2023-12-31",
    link: "/documents/Sectorials/T1_Annuaire_2021_2022_VF.pdf"
  },
];

function MinistereEducation() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState(statistiquesEducationData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    let filtered;

    if (year === 'Tous') {
      filtered = statistiquesEducationData;
    } else {
      filtered = statistiquesEducationData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });
    }

  
    filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    
    setFilteredStatistiques(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère de l’Éducation Nationale et de la Recherche Scientifique
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère de l’Éducation Nationale et de la Recherche Scientifique est responsable de l’amélioration de la qualité de l’éducation et de la recherche dans le pays. Cette page présente des statistiques importantes sur l’éducation, allant de l’enseignement préscolaire à l’enseignement supérieur, et vise à informer les parties prenantes sur les développements récents.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de réalisation"
            >
              <MenuItem value="Tous">Tous les annuaires</MenuItem>
              {[...new Set(statistiquesEducationData.map((statistique) => new Date(statistique.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                       target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={"assets/annuaires/minieduc.png"} 
                        alt={statistique.annuaires}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={statistique.link}
                         target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{statistique.annuaires}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereEducation;